export default __webpack_public_path__ + "static/network-1@2x-9c8d569a6977be5536f15d96d7bad8d1.png";